import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import type { LaunchResult } from "../../../api/document/ValidationAgent";
import {
  CAPTION_ERROR_REASON_GENERIC,
  CAPTION_ERROR_REASON_MISSING_OBJECTS,
  CAPTION_ERROR_REASON_MISSING_TAG,
  CAPTION_ERROR_REASON_NON_NUMERIC,
  CAPTION_ERROR_REASON_SCRIPT_ERROR,
} from "./validationCaptions";

export function localizeErrorReason(errorReason: LaunchResult["errorReason"] | undefined): string {
  switch (errorReason) {
    case "MISSING_TAG":
      return formatMessage(CAPTION_ERROR_REASON_MISSING_TAG);
    case "MISSING_OBJECTS":
      return formatMessage(CAPTION_ERROR_REASON_MISSING_OBJECTS);
    case "NON_NUMERIC_VALUE":
      return formatMessage(CAPTION_ERROR_REASON_NON_NUMERIC);
    case "SCRIPT_ERROR":
      return formatMessage(CAPTION_ERROR_REASON_SCRIPT_ERROR);
    default:
      return formatMessage(CAPTION_ERROR_REASON_GENERIC);
  }
}
